import React from 'react';

import { observer } from 'mobx-react';
import Calendar from './calendar';
import EventsList from './events';
import Filters from './filters';

import { ThemedEventList, ThemedTitle } from '../../themes';

const Title = ({ title, currentFilter, unsetFilter, currentDate, unsetDate }) => {
  return (
    <ThemedTitle
      title={ title }
      currentFilter={ currentFilter }
      currentDate={ currentDate }
      unsetFilter={ unsetFilter }
      unsetDate={ unsetDate }
    />
  );
};

const Events = observer(({ store, maxEvents, displayLargeTiles }) => {
  const title = (
    <Title
      title={ store.title }
      currentFilter={ store.currentFilter }
      currentDate={ store.currentDate }
      unsetFilter={ store.unsetFilter }
      unsetDate={ store.unsetDate }
    />
  );
  const filters = (
    <Filters
      filters={ store.filters }
      activeFilters={ store.activeFilters }
      setFilter={ store.setFilter }
    />
  );
  const calendar = (
    <Calendar
      calendar={ store.calendar }
      currentDate={ store.currentDate }
      activeDates={ store.activeDates }
      setDate={ store.setDate }
    />
  );
  const events = (
    <EventsList
      events={ store.filteredEvents }
      shortlist={ store.shortlistStore }
      extraTiles={ store.extraTiles }
      eventCount={ store.eventCount }
      maxEvents={ maxEvents }
      nextPage={ store.nextPage }
      hasMoreEvents={ store.hasMoreEvents }
    />
  );
  return (
    <ThemedEventList
      title={ title }
      filters={ filters }
      calendar={ calendar }
      events={ events }
      displayLargeTiles={ displayLargeTiles }
    />
  );
});

export default Events;
